import Vue from 'vue';

import App from '@/app.vue';
import router from '@/services/router/router.service';
import http from '@/services/rest/rest.service';
import VeeValidate from 'vee-validate';

import '@/styles/main.scss';
import store from '@/store/store';
import { registerEntities } from '@/register';

registerEntities();

Vue.use(VeeValidate);

Vue.config.productionTip = false;
Vue.prototype.$http = http;

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
